import { Link } from 'react-router-dom';

import { Stone } from '@app/shared/ui/molecules/Common';
import { cn, telegramVibrate } from '@app/shared/utils/common';
import { EnergyStoneModel } from '@app/store/slices/stones/stoneTypes';
import { Page } from '@app/routes';
import { PulsingGlowWrapper } from '@app/shared/ui/molecules/Home';
import { Tutorial } from '@app/shared/ui/organisms/Common';
import { t } from 'i18next';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { tutorialActions } from '@app/store/slices/tutorial/tutorialSlice';

interface AllStonesProps {
  stones: EnergyStoneModel[];
  containerClassName?: string;
}

export function AllStones({ stones, containerClassName }: AllStonesProps) {
  const dispatch = useAppDispatch();
  const tutorial = useAppSelector((state) => state.tutorial);

  const stoneElement = (stone: EnergyStoneModel, shouldPulse = false) => (
    <Link
      to={`${Page.STONE_ABILITIES}?stone=${String(stone.id)}`}
      onClick={() => dispatch(tutorialActions.onStoneClick())}
    >
      <Stone
        nodeLevel={stone.nodeLevel}
        key={stone.id}
        image={stone.imageUrl}
        isPurchased={stone.isPurchased}
        cardColor={!stone.isPurchased && !shouldPulse ? 'grayscale' : ''}
      />
    </Link>
  );

  return (
    <ul className={cn('flex gap-1 justify-between', containerClassName)}>
      {stones.map((stone, i) => {
        const shouldPulse = i === 0 && !stone.isPurchased;
        const isTutorial = i === 0 && tutorial.step === 'HOME_STONE_1';
        return (
          <li
            key={stone.id}
            onClick={() => {
              telegramVibrate();
            }}
          >
            {isTutorial ? (
              <Tutorial text={t('tutorial.stone.1_step')} enabled={isTutorial} shouldPulse={true}>
                <PulsingGlowWrapper
                  className="p-0! w-fit"
                  pulsationClassName="size-[103%] -left-px -top-px pointer-events-none bg-[radial-gradient(circle_at_center,#46211c_0%,#8c3a2f_55%,#c56a5b_100%)]"
                >
                  {stoneElement(stone, shouldPulse)}
                </PulsingGlowWrapper>
              </Tutorial>
            ) : shouldPulse ? (
              <PulsingGlowWrapper
                className="p-0! w-fit"
                pulsationClassName="size-[103%] -left-px -top-px pointer-events-none bg-[radial-gradient(circle_at_center,#46211c_0%,#8c3a2f_55%,#c56a5b_100%)]"
              >
                {stoneElement(stone, shouldPulse)}
              </PulsingGlowWrapper>
            ) : (
              stoneElement(stone)
            )}
          </li>
        );
      })}
    </ul>
  );
}
